if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

document.addEventListener('DOMContentLoaded', function () {
  accordionSetting(); // 試合成績のアコーディオンの設定
  showMoreProcess();  // 「もっと見る」の処理
});

/**
 * 試合成績のアコーディオンの設定
 */
function accordionSetting() {
  const toggles = document.querySelectorAll('.js-accordion-toggle');

  // URLからパラメーター（ハッシュ）を取得
  const hash = window.location.hash;

  let targetEl = null;
  let originalId = '';

  // ブラウザの標準ジャンプを無効化するためIDを一時的に削除
  if (hash) {
    try {
      targetEl = document.querySelector(hash);
      if (targetEl && targetEl.classList.contains('day-group')) {
        originalId = targetEl.id;
        targetEl.id = '';
      } else {
        targetEl = null;
      }
    } catch (err) {
      targetEl = null;
    }
  }

  toggles.forEach(function(toggle, index) {
    const content = toggle.nextElementSibling;
    if (!content || !content.classList.contains('js-accordion-content')) return;

    let isOpen = false;

    if (targetEl) {
      // パラメーターと一致した要素を開ける
      isOpen = (toggle.closest('.day-group') === targetEl);
    } else {
      // パラメータがない場合は一番目の要素を開ける
      isOpen = (index === 0);
    }

    if (isOpen) {
      toggle.classList.remove('is-close');
      content.style.display = 'block';
    } else {
      toggle.classList.add('is-close');
      content.style.display = 'none';
    }
  });

  const getScrollOffset = function(element) {
    if (!element) return 0;
    // 該当要素に当たっているすべてのCSS（計算済みスタイル）を取得
    const style = window.getComputedStyle(element);
    // 'scroll-margin-top' の値を取得
    const offset = parseFloat(style.getPropertyValue('scroll-margin-top'));
    
    return isNaN(offset) ? 0 : offset;
  };

  // スクロール処理
  if (targetEl) {
    const adjustScroll = function() {
      const offset = getScrollOffset(targetEl);
      const topPos = targetEl.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo(0, topPos);
    };

    adjustScroll();

    window.addEventListener('load', function() {
      setTimeout(function() {
        adjustScroll();
        targetEl.id = originalId; 
      }, 10);
    });
  }

  // 見出しをクリックした際のアコーディオン開閉
  toggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      const content = this.nextElementSibling;
      if (!content || !content.classList.contains('js-accordion-content')) return;

      // 連打対策（アニメーション中は無視する）
      if (this.classList.contains('is-animating')) return;

      // 現在の開閉状態を判定
      const isCurrentlyOpen = !this.classList.contains('is-close');

      // アニメーション開始（連打対策のクラスを付与）
      this.classList.add('is-animating');

      if (isCurrentlyOpen) {
        // 【閉じる処理】
        this.classList.add('is-close'); // 先にアイコンを「＋」にする
        content.classList.add('is-closing'); // 閉じるアニメーション開始
        
        // アニメーションの秒数（0.2s）に合わせる
        setTimeout(function() {
          content.classList.remove('is-closing');
          content.style.display = 'none';
          toggle.classList.remove('is-animating');
        }, 200);
      } else {
        // 【開く処理】
        this.classList.remove('is-close'); // アイコンを「－」にする
        content.style.display = 'block'; // 表示してアニメーション開始

        // アニメーションの秒数（0.2s）に合わせる
        setTimeout(function() {
          toggle.classList.remove('is-animating');
        }, 200);
      }
    });
  });

  // ページ内リンクをクリックした時の処理
  const anchorLinks = document.querySelectorAll('.anchor-btn');
  anchorLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      // ブラウザの標準ジャンプ機能をキャンセル
      e.preventDefault();

      const targetId = this.hash.replace('#', '');
      const targetGroup = document.getElementById(targetId);

      if (targetGroup) {
        const toggleBtn = targetGroup.querySelector('.js-accordion-toggle');
        const content = targetGroup.querySelector('.js-accordion-content');

        let waitTime = 0; // スクロールを待つ時間

        // もし対象のアコーディオンが閉じていたら開く
        if (toggleBtn && toggleBtn.classList.contains('is-close')) {
          toggleBtn.classList.remove('is-close');
          if (content) {
            content.classList.remove('is-closing');
            content.style.display = 'block';
            waitTime = 200;
          }
        }

        // 高さを確定後にスクロール
        setTimeout(function() {
          const offset = getScrollOffset(targetGroup);
          const topPos = targetGroup.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({ top: topPos, behavior: 'smooth' });
        }, waitTime);
        
        history.pushState(null, null, this.hash);
      }
    });
  });
}

/**
 * 「もっと見る」の処理
 */
function showMoreProcess() {
  const showMoreBtns = document.querySelectorAll('.js-show-more-btn');

  showMoreBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const targetId = this.getAttribute('data-target');
      const wrapperId = this.getAttribute('data-wrapper');
      const list = document.getElementById(targetId);

      if (!list) return;

      // 非表示アイテム（li.is-hidden）を取得
      const hiddenItems = list.querySelectorAll('li.is-hidden');
      const showCount = 10; // 1回で表示する件数

      // 指定した件数分だけ表示処理を行う
      for (let i = 0; i < showCount && i < hiddenItems.length; i++) {
          hiddenItems[i].style.display = '';
          hiddenItems[i].classList.remove('is-hidden');
      }

      // 次に開く要素がない場合はボタンの要素ごと非表示にする
      if (hiddenItems.length <= showCount) {
          const wrapper = document.getElementById(wrapperId);
          if (wrapper) {
              wrapper.style.display = 'none';
          }
      }
    });
  });
}